<template>
  <v-card outlined class="fill-height">
    <v-card-text>
      <SectionTitle :title="$t('views.production-foreman.supplierList')"/>
      <v-data-table
        :headers="headers"
        :items="items"
        style="overflow: auto"
        height="100%"
        dense
        fixed-header
        single-select
        disable-pagination
        hide-default-footer
        class="row-pointer mt-2"
      >
        <template #headerCell="{ header }">
          <span
            class="subheading font-weight-light text-success text--darken-3"
            v-text="header.text"
          />
        </template>
        <template #item="{ item }">
          <tr
            :class="{ 'grey lighten-2': item._id === selectedItem }"
            @click="onSupplierSelected(item)"
          >
            <td class="font-weight-semibold">{{ $helpers.format.supplier(item) }}</td>
            <td class="text-end">
              <TrendChip
                v-if="item.kpi"
                :risk="item.kpi.risk"
                :date="new Date(item.kpi.date)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import SectionTitle from '@/components/core/SectionTitle.vue'
import TrendChip from '@/components/DashViews/Charts/TrendChip.vue'

export default {
  name: 'SupplierList',
  components: {
    SectionTitle,
    TrendChip,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: String,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('enums.headers.supplierCity'),
          value: 'title',
          sortable: false,
        },
        {
          text: this.$t('enums.headers.avgQualityIndex'),
          value: 'qualityIndex',
          sortable: false,
          align: 'end',
        },
      ]
    },
  },
  methods: {
    onSupplierSelected(value) {
      if (value._id !== this.selectedItem) {
        this.$emit('onSupplierSelected', value._id)
      }
    },
  },
}
</script>

<style scoped lang="scss"> 
  @import '@/styles/material-dashboard/variables.scss';
  .supplier-list {
    .v-card__text {
      padding: 20px 0 0;
    }
    .sectiontitle-root {
      padding: 0 16px;
    }
    .v-data-table {
      border-radius: 16px;
    }
  }

  td {
    font-family: $body-font-family;
  }
</style>